import { render } from "./StoresManagement.vue?vue&type=template&id=744e4f28&scoped=true"
import script from "./StoresManagement.vue?vue&type=script&lang=js"
export * from "./StoresManagement.vue?vue&type=script&lang=js"

import "./StoresManagement.vue?vue&type=style&index=0&id=744e4f28&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744e4f28"]])

export default __exports__